import { render, staticRenderFns } from "./gaincode.vue?vue&type=template&id=a5edb07a&scoped=true&"
import script from "./gaincode.vue?vue&type=script&lang=js&"
export * from "./gaincode.vue?vue&type=script&lang=js&"
import style0 from "./gaincode.vue?vue&type=style&index=0&id=a5edb07a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a5edb07a",
  null
  
)

export default component.exports